// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"886":"cc5fd4db","1872":"cc5fd4db","2523":"e47b22d4"}[chunkId] + ".chunk.css";
};